import { roles } from 'commons/auth/roles';
import { permissionOperations } from "commons/auth/permission";

type StatusOption = { value: string; label: string };

export default class Status {
  /**
   * This method is used to check status and return props for element
   * @param profileRoles
   * @param userPermissionOperations
   * @param ecrfStatus
   * @param status
   * @param mode
   */
  public static controller(
    profileRoles: any,
    userPermissionOperations: any,
    ecrfStatus?: any,
    status?: any,
    mode?: any
  ) {
    if (userPermissionOperations.some(
      (operation: string) => permissionOperations.edit.includes(operation)
    )) {
      return false;
    }

    if (profileRoles.some(
      (role: string) => roles.monitor.includes(role)
    )) {
      return true;
    }

    // ecrf status (field lock status: SIGNED, BLOCKED)
    switch (ecrfStatus) {
      case 4: // SIGNED
      case 7: { // BLOCKED
        return true;
      }
    }

    // element mode
    switch (mode) {
      case 'block': {
        return true;
      }
    }

    return !!status;
  }

  /**
   * disabled
   */
  public static disabled(profileRoles: any) {
    return !profileRoles.some((role: string) => (
      roles.admin.includes(role) || (
        roles.monitor.includes(role) && !roles.readonly.includes(role)
      )
    ));
  }

  /**
   * statuses
   * @param profileRoles
   * @param elementStatuses
   */
  public static statuses(
    profileRoles: string[],
    elementStatuses: Record<string, string>
  ): StatusOption[] {
    const entries = Object.entries(elementStatuses);

    if (profileRoles.includes('ROLE_C_RESEARCHER')) {
      return entries.map(([value, label]) => ({ value, label }));
    }

    return entries
      .filter(([_, label]) => typeof label === 'string' && label.toLowerCase() !== 'signed')
      .map(([value, label]) => ({ value, label }));
  }
}
